// extracted by mini-css-extract-plugin
export default {"EditVersionForm":"EditVersionForm1QPUnWK8koRl","EditVersionForm-details":"EditVersionForm-details2Go26K4ReDvC"};